var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',_vm._b({on:{"submit":function($event){$event.preventDefault();return _vm.submit()}}},'form',{..._vm.$attrs,..._vm.$props},false),[_vm._t("before",null,{"rform":_vm.self}),_vm._v(" "),_c('div',{class:_vm.classContent},[_vm._t("default",null,{"rform":_vm.self})],2),_vm._v(" "),_vm._t("after",null,{"rform":_vm.self})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }